<script lang="ts">
  import TextNew from "../TextNew.svelte";
  import Icon from "../icons/Icon.svelte";

  type CardVariant = "default" | "link";

  export let step: number = 1;
  export let title: string;
  export let variant: CardVariant = "default";
  export let url: string | undefined = undefined;
</script>

<svelte:element
  this={variant === "default" ? "div" : "a"}
  class="card"
  href={url}
  target={url ? "_blank" : undefined}
  class:card-link={variant === "link"}
  tabindex={0}
>
  <div class="badge" class:link-badge={variant === "link"}>
    {#if variant === "link"}
      <Icon name="arrowOpen" --w="24px" --h="24px" />
    {:else}
      <div class="step-offset">
        <TextNew size="s" --size="23px" --line-height="initial">
          {step}
        </TextNew>
      </div>
    {/if}
  </div>
  <div class="diatype-align">
    <div class="title-container">
      <TextNew size="l" weight="regular">
        {title}
      </TextNew>
    </div>

    <slot />
  </div>
</svelte:element>

<style>
  .card {
    display: flex;
    padding: 16px 24px var(--pb, 16px) 16px;
    border-radius: var(--rk-rounding-s);
    background-color: var(--rk-primary-light);
    gap: 12px;
  }

  .diatype-align {
    padding: 7px 0px;
  }

  .step-offset {
    position: relative;
    top: 3px;
  }

  .card-link {
    text-decoration: none;
  }

  .link-badge {
    color: var(--rk-text-dark);
    transition: color 0.15s cubic-bezier(0.65, 0, 0.35, 1),
      background-color 0.15s cubic-bezier(0.65, 0, 0.35, 1);
  }

  .card-link:focus-visible > .link-badge,
  .card-link:hover > .link-badge {
    color: var(--rk-text-light);
  }

  .card-link:focus-visible > .link-badge,
  .card-link:hover > .link-badge {
    background-color: var(--rk-primary-dark);
  }

  .badge {
    display: flex;
    flex: 0 0 56px;
    justify-content: center;
    align-items: center;
    padding: 6px 8px;
    height: 40px;
    background: var(--rk-neutral-1);
    border-radius: 100px;
  }

  .title-container {
    margin-bottom: 4px;
  }
</style>
